<template>
  <div>
    <CCol sm="12" class="pl-0 pr-0">
      <table class="table">
        <thead>
          <tr class="table-success">
            <th scope="col" class="min-width-50">Sr.No.</th>
            <th>Name</th>
            <th>Show On Frontend</th>
            <th>Base Amount</th>
            <th>#</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(plan, index) in plans" :key="plan._id">
            <td>{{ index + 1 }}</td>
            <td>{{ plan.settings.plan_name }}</td>
            <td>{{ plan.settings.show_on_frontend }}</td>
            <td>{{ plan.settings.base_amount }}</td>
            <td>
              <v-btn @click="goToPlanPage(plan._id)" class="btn btn-primary">View details</v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </CCol>
  </div>
</template>
<script>
import config from "@/config.js";
export default {
  props: ["role"],

  data() {
    return {
      plans: []
    };
  },
  mounted() {
    this.getPlans();
  },
  methods: {
    getPlans() {
      const params = { role: this.role };
      let url = `${config.BASE_URL}api/v2/admin/subscriptions`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.plans = response.body.data;
        }
      });
    },
    goToPlanPage(id) {
      this.$router.push({
        name: "View Subscription",
        params: { id: id }
      });
    }
  }
};
</script>